import _ from 'lodash';
import React, { useContext } from 'react';
export const DefaultErrorCodes = {
    ERROR_UNKNOWN_ERROR: 'ERROR_UNKNOWN_ERROR',
    GRAPHQL_VALIDATION_ERROR: 'GRAPHQL_VALIDATION_ERROR',
    NW_ERROR: 'NW_ERROR',
    '*': '*',
};
let ErrorContext;
const initErrorContext = () => {
    var _a, _b;
    if (!ErrorContext) {
        if ((_a = window === null || window === void 0 ? void 0 : window.blink) === null || _a === void 0 ? void 0 : _a.ErrorContext) {
            ErrorContext = (_b = window === null || window === void 0 ? void 0 : window.blink) === null || _b === void 0 ? void 0 : _b.ErrorContext;
        }
        else {
            ErrorContext = React.createContext({
                errors: [],
                combinedErrors: [],
                postError: errs => _.noop(),
                resetError: _.noop,
            });
            window.blink = window.blink || {};
            window.blink.ErrorContext = ErrorContext;
        }
    }
    return ErrorContext;
};
initErrorContext();
const useGetErrorInfo = () => {
    if (!ErrorContext) {
        initErrorContext();
    }
    const errorCtx = useContext(ErrorContext);
    return {
        errors: errorCtx.combinedErrors,
        resetErrors: errorCtx.resetError,
    };
};
export { useGetErrorInfo, ErrorContext };
//# sourceMappingURL=error-context.js.map